import { defineComponent } from "vue";
import { usePortalStore } from "@/framework/portal";

export default defineComponent ({
    name: "ActionPage",
    inheritAttrs: false,
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: false
        }
    },
    setup() {
        const portal = usePortalStore()
        
        return {
            portal
        };
    },
    created() {
        const self = this;
        if (this.portal.navPageConfig[this.portal.currentNavIndex].continue) {
            this.portal.navPageConfig[this.portal.currentNavIndex].continue();
            setTimeout(function () {
                self.portal.currentNavIndex++;
                window.scrollTo(0, 0);
            }, 100);
        }
        else {
            this.portal.currentNavIndex++;
            window.scrollTo(0, 0);
        }
    }
});